<template>
  <div>
    <li class="dkillItem" @click="enterDetails()" :class="{ disabled: showStatus(courseInfo) }">
      <p class="dkillTitle">
        <i v-if="courseInfo.productName.substr(0, 1) == '【'"></i>
        {{ courseInfo.productName }}
      </p>
      <div class="TimeHours">
        <p class="Time" v-if="courseInfo.startTime">
          <img src="@/assets/img/public/time1.png" alt="" />开课时间:<span>{{
            courseInfo.startTime.slice(0, 11)
          }}</span>
        </p>
        <!-- <p class="hourse" v-if="courseInfo.classPeriod">
          <img src="@/assets/img/public/time2.png" alt="" />课时:<span>{{
            courseInfo.classPeriod
          }}</span>
        </p> -->
      </div>
      <!-- 教师头像  -->
      <ol class="teacherList">
        <ul>
          <li v-for="(item, index) in courseInfo.teacherRespVOList&&courseInfo.teacherRespVOList.length > 3
              ? courseInfo.teacherRespVOList.slice(0, 3)
              : courseInfo.teacherRespVOList" :key="index">
            <img :src="item.teacherHead || defaultImg" alt="" />
            <p>{{ item.name }}</p>
          </li>
        </ul>
        <!-- 售价 -->
        <div class="coursePrice">
          <img v-if="showStatus(courseInfo)" :src="showStatus(courseInfo)" alt="" />
          <del v-if="courseInfo.originalPrice">￥{{ courseInfo.originalPrice }}</del>
          <p class="free" v-if="!courseInfo.sellPrice">
            <b>限时免费</b>
          </p>
          <p class="showPic" v-else>
            <template>
              <b>¥</b>
              <span>{{ courseInfo.sellPrice }}</span>
            </template>
          </p>
        </div>
      </ol>
    </li>
  </div>
</template>

<script>
import defaultImg from '@/assets/img/loginImg/default.png';
import buy from '@/assets/img/public/buy.png';
import sellOut from '@/assets/img/public/sold.png';
import soldOut from '@/assets/img/public/sell.png';
import expire from '@/assets/img/public/time.png';

export default {
  components: {},
  props: {
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sellOut,
      soldOut,
      buy,
      expire,
      defaultImg,
    };
  },
  computed: {},
  methods: {
    // 进入详情
    enterDetails() {
      const { courseInfo } = this;
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(courseInfo.productId), false);
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: courseInfo.productId,
        },
      });
      sessionStorage.setItem('back', true);
    },
    showStatus(courseInfo) {
      const {
        isBuy, isExpire, isSoldOut, isOffline,
      } = courseInfo;
      let status = false;
      if (isBuy) {
        status = this.buy;
      } else if (isOffline) {
        status = this.soldOut;
      } else if (isSoldOut) {
        status = this.sellOut;
      } else if (isExpire) {
        status = this.expire;
      }
      return status;
    },
  },
};
</script>

<style lang="scss" scoped>
.dkillItem {
  margin-bottom: 18px;
  padding: 20px 29px 25px 25px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 9px 0 #eee;
}

.dkillTitle {
    display: -webkit-box;
    margin: 0 0 15px 0;
  overflow: hidden;
  color: $fontColorBlack;
  font-weight: bold !important;
  font-size: 33px;
  line-height: 45px;
  @extend .ellipsis-2;
  i {
    margin-left: -18px;
  }
}

.TimeHours {
  display: flex;
  align-items: center;
  line-height: 30px;
  .hourse {
    padding: 0 0 0 30px;
  }
  p {
    display: flex;
    align-items: flex-start;
    align-items: center;
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 24px;
    img {
      width: 24px;
      margin-right: 5px;
    }
  }
  span {
    margin-left: 5px;
    color: $fontColorGray;
    font-size: 24px;
  }
}
.teacherList {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  margin-top: 30px;
  ul {
    display: flex;
    width: 360px;
    overflow: hidden;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // width: 64px;
      margin-right: 34px;
      img {
        width: 63px;
        height: 63px;
        border-radius: 50%;
      }
      p {
        max-width: 120px;
        margin-top: 9px;
        overflow: hidden;
        color: $fontColorGray;
        font-size: 22px;
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.coursePrice {
  position: absolute;
  right: 0;
  bottom: 5px;
  display: flex;
  align-items: baseline;
  > img {
    position: absolute;
    right: 0;
    bottom: 40px;
    width: 130px;
  }
  del {
    margin-right: 11px;
    color: $fontColorGray;
    font-size: 24px;
  }
  .courseType {
    color: $theme_color;
    font-weight: 500;
    font-size: 28px;
  }
}
.free {
  b {
    color: $theme_color;
    font-size: 33px;
  }
}
.showPic {
  margin-left: 6px;
  font-weight: bold;
  font-size: 28px;
  text-align: center;
  b {
    margin: 0 4px;
    color: $theme_color;
    font-size: 28px;
  }
  span {
    color: $theme_color;
    font-size: 33px;
  }
  .fontSty {
    font-size: 30px;
  }
}
.dkillItem.disabled {
  background: #f6f6f6;
  .dkillTitle,
  p,
  b,
  span {
    color: #979797 !important;
  }
  .teacherList ul li img {
    opacity: 0.5;
  }
}
</style>
